import Vue from 'vue';
import http from './http_services'

const contests = {
	state: {
		master_contest_list: [],
    contest_sponsors: []
	},

  get_current_master_contest_list: function() {
    return this.state.master_contest_list;
  },

  get_master_contest_list: function(instanceid) {
    let vm = this;

    if(vm.state.master_contest_list.length > 0) {
      // return vm.state.master_contest_list;
    }
    else {
      // GET CONTEST LIST FROM DB
      vm.fetch_master_contest_list(instanceid)
        .then(function(response) {
          Vue.set(vm.state, 'master_contest_list', response.data.data);
        })
    }
  },

  get_single_contest: function(instance_contestid) {
    let vm = this;
    let single_contest = {};
    
    // GET FROM MASTER_CONTEST_LIST LOCALLY
    for(var key in vm.state.master_contest_list) {
      if(vm.state.master_contest_list[key].instance_contestid == instance_contestid) {
        single_contest = vm.state.master_contest_list[key];
      }
    }

    return single_contest;
  },

  get_batch_contest_voting_details: function(instance_contestid_list, userid) {
    // console.log('instance_contestid_list: ', instance_contestid_list);
    if(instance_contestid_list instanceof Array) {
      return this.fetch_batch_contest_voting_details(instance_contestid_list, userid);
    }
    else {
      return false;
    }
  },

  get_current_contest_sponsors: function(instance_contestid) {
    let vm = this;
    let sponsors = [];
    
    for(var key in vm.state.contest_sponsors) {
      if(typeof vm.state.contest_sponsors[key].instance_contestid != 'undefined') {
        if(vm.state.contest_sponsors[key].instance_contestid == instance_contestid) {
          sponsors.push(vm.state.contest_sponsors[key]);
        }
      }
    }

    return sponsors;
  },

  get_contest_sponsors: function(instance_contestid) {
    let vm = this;
    let sponsors_exist = false;
    
    // CHECK TO SEE IF SPONSORS ALREADY EXIST FOR THIS CONTEST
    for(var key in vm.state.contest_sponsors) {
      if(vm.state.contest_sponsors[key].instance_contestid == instance_contestid) {
        sponsors_exist = true;
      }
    }

    // RETRIEVE SPONSOR LIST FROM DB IF NOT ALREADY PRESENT
    if(!sponsors_exist) {
      vm.fetch_contest_sponsors(instance_contestid)
        .then(function(response) {
          // LOOP THROUGH RESULTS TO STORE EACH SPONSOR INDIVIDUALLY
          for(var key in response.data.data) {
            vm.state.contest_sponsors.push(response.data.data[key]);
          }
        })
    }
  },

  fetch_master_contest_list: function(instanceid) {
    let vm = this;
    let requested_set = 'master_contest_list'

    return http.get_api_data(requested_set, {instanceid: instanceid});
  },

  fetch_contest_sponsors: function(instance_contestid) {
    let vm = this;
    let requested_set = 'contest_sponsors'

    return http.get_api_data(requested_set, {instance_contestid: instance_contestid});
  },

  fetch_batch_contest_voting_details: function(instance_contestid_list, userid) {
    let vm = this;
    let requested_set = 'batch_contest_voting_details';
    let options = {
      list: instance_contestid_list,
      userid: userid
    }

    return http.get_api_data(requested_set, options);
  }

}

export default contests


// WEBPACK FOOTER //
// ./src/store/modules/mod_contests.js